/* eslint-disable @typescript-eslint/naming-convention */
import { ParameterInfos } from 'ut-business/parameter';

const BASE_NUMERIC_FIELD = {
  sourceUnit: 'm' as const,
  metric: {
    unit: 'mm' as const,
    decimals: 1,
    limit: {
      min: 0,
    },
    defaultStep: 1,
    steps: [
      0.1,
      1,
      10,
    ],
  },
  imperial: {
    unit: 'in' as const,
    decimals: 1,
    limit: {
      min: 0,
    },
    defaultStep: 1,
    steps: [
      0.1,
      1,
      10,
    ],
  },
  inspectionMode: {
    analysis: {
      isReadOnly: false,
    },
  },
};

export const analysisParameters: Record<string, ParameterInfos> = {
  Analysis_Mean: {
    percent: {
      unit: '%',
      decimals: 3,
    },
    decibel: {
      unit: 'dB',
      decimals: 2,
    },
    sourceUnit: '%',
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  Analysis_StandardDeviation: {
    percent: {
      unit: '%',
      decimals: 3,
    },
    decibel: {
      unit: 'dB',
      decimals: 2,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  Analysis_Snr: {
    metric: {
      unit: '',
      decimals: 2,
    },
    imperial: {
      unit: '',
      decimals: 2,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  Analysis_OtherSnr: {
    metric: {
      unit: '',
      decimals: 2,
    },
    imperial: {
      unit: '',
      decimals: 2,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  Analysis_Threshold: {
    percent: {
      unit: '%',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    sourceUnit: '%',
    decibel: {
      unit: 'dB',
      decimals: 2,
      defaultStep: 0.1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  Analysis_OtherThreshold: {
    percent: {
      unit: '%',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    sourceUnit: '%',
    decibel: {
      unit: 'dB',
      decimals: 2,
      defaultStep: 0.1,
      steps: [
        0.01,
        0.1,
        1,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  Analysis_DefectArea: {
    metric: {
      unit: 'mm²',
      decimals: 2,
    },
    imperial: {
      unit: 'in²',
      decimals: 3,
    },
    sourceUnit: 'm²',
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  Analysis_TotalArea: {
    metric: {
      unit: 'mm²',
      decimals: 2,
    },
    imperial: {
      unit: 'in²',
      decimals: 3,
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  Analysis_DefectAreaPercent: {
    metric: {
      unit: '%',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    imperial: {
      unit: '%',
      decimals: 1,
      defaultStep: 0.1,
      steps: [
        0.01,
        0.1,
        1,
      ],
      limit: {
        min: 0,
        max: 100,
      },
    },
    sourceUnit: '%',
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  Analysis_ThresholdUsage: {
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  Analysis_Contrast: {
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  Analysis_Minimum_Material_Loss: {
    sourceUnit: '%',
    metric: {
      unit: '%',
      decimals: 1,
      defaultStep: 1,
      limit: {
        min: 0,
        max: 100,
      },
      steps: [
        0.1,
        1,
        10,
      ],
    },
    inspectionMode: {
      analysis: {
        isReadOnly: false,
      },
    },
  },
  Analysis_Minimum_Thickness: BASE_NUMERIC_FIELD,
  Analysis_Minimum_Indication_Size: BASE_NUMERIC_FIELD,
  Analysis_Interaction_Scan: BASE_NUMERIC_FIELD,
  Analysis_InteractionIndex: BASE_NUMERIC_FIELD,
};
